import { DataGrid } from "@mui/x-data-grid";

const NomineeDetails = (nominees) => {
  return (
    <DataGrid
      rows={nominees.nominees}
      columns={nominees.columns}
      initialState={{
        pagination: {
          paginationModel: {
            pageSize: 10,
          },
        },
      }}
      sx={{
        ".css-yrdy0g-MuiDataGrid-columnHeaderRow": {
          backgroundColor: "#f3f3f9 !important",
        },
        ".MuiTablePagination-displayedRows": {
          marginBottom: 0,
        },
        ".css-1qb993p-MuiDataGrid-columnHeaderTitle": {
          fontWeight: "bold",
          fontSize: "16px",
        },
      }}
    />
  );
};

export default NomineeDetails;
